<template>
  <PublicPopup
    ref="PopupRef"
    type="fullScreen"
    :height="90"
    position="bottom"
    @close="emit('close')"
  >
    <template #content>
      <div class="download-guide-popup">
        <div class="header-container">
          <p class="title">{{ $t('DownloadPopup-DownloadGuidePopup.title') }}</p>
          <van-icon name="close" class="close-icon" @click="handlePopupClose" />
        </div>

        <div class="content-card-title">
          <p class="title">{{ $t('DownloadPopup-DownloadGuidePopup.step1Title') }}</p>
          <span class="content">
            {{ $t('DownloadPopup-DownloadGuidePopup.openPrefix') }}
            <span class="web-name">{{ AppName }}</span>
            {{ $t('DownloadPopup-DownloadGuidePopup.openSuffix') }}
          </span>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img
            :src="getImageUrlWithCDN_TEST('/home/download_guide_1.webp', 'local')"
            class="images"
          />
        </div>

        <div class="content-card-title">
          <p class="title">{{ $t('DownloadPopup-DownloadGuidePopup.step2Title') }}</p>
          <span class="content">
            {{ $t('DownloadPopup-DownloadGuidePopup.step2Content') }}
          </span>
        </div>
        <div class="content-card-images chxy-row-c-c">
          <img
            :src="getImageUrlWithCDN_TEST('/home/download_guide_2.webp', 'local')"
            class="images"
          />
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const AppName = computed(() => {
  return JSON.parse(localStorage.getItem('localConfig')).appName || ''
})

const { t } = useI18n()

const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.download-guide-popup {
  padding: 10px;
  width: 100%;
  height: 100%;
  background-color: var(--download-guide-popup-bg);

  .header-container {
    position: relative;
    width: 100%;
    height: 48px;
    font-size: 16px;
    text-align: center;
    line-height: 48px;

    .title {
      color: var(--popup-primary-title);
    }
    .close-icon {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      color: var(--download-guide-popup-close-icon);
    }
  }

  .content-card-title {
    margin-top: 12px;

    .title {
      font-size: 14px;
      color: var(--download-guide-popup-content-label);
    }

    .content {
      font-size: 12px;
      color: var(--download-guide-popup-content-text);

      .web-name {
        color: var(--download-guide-popup-content-web);
      }
    }
  }

  .content-card-images {
    margin-top: 12px;

    .images {
      width: 90%;
    }
  }
}
</style>
